import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "grid"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "grid-item"
};
const _hoisted_4 = ["href"];
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "image-slot"
}, null, -1);
const _hoisted_6 = {
  class: "box-info p-20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("ul", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.buyList, (buyItem, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: "col-3 grid-li",
      key: index
    }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("a", {
      href: buyItem.buyLink,
      target: "_blank"
    }, [_createVNode(_component_el_image, {
      class: "buy-img",
      src: require('@/assets/buy/' + buyItem.buyType + '.jpg'),
      fit: "cover",
      lazy: _ctx.lazy
    }, {
      placeholder: _withCtx(() => [_hoisted_5]),
      _: 2
    }, 1032, ["src", "lazy"])], 8, _hoisted_4), _createElementVNode("div", _hoisted_6, [_createElementVNode("h2", null, _toDisplayString($data.isEnOrZh == "en" ? buyItem.content.en : buyItem.content.zh), 1)])])]);
  }), 128))])]);
}